<div class="rx-profile-content t-scrollbar">
  <div class="opt-container">
    <div *ngFor="let opt of options" class="opt">
      <checkbox-wrap class="checkbox" label="{{ opt.text }}">
        <input type="checkbox" [(ngModel)]="opt.selected" />
      </checkbox-wrap>
      <img *ngIf="opt.icon" src="assets\img\rx_icons\{{ opt.icon }}" />
    </div>
  </div>
</div>
